import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import MakeRequest from '../Components/Helpers/MakeRequest';
import { useOutletContext, Link, useNavigate } from 'react-router-dom';

const Reports = () => {
  const { l } = useOutletContext();
  const navigate = useNavigate();

  const [reports, setReports] = useState([]);
  const [visibleCount, setVisibleCount] = useState(12); // 4 rows * 3 cards per row on lg
  const [pageContent, setPageContent] = useState({
    ingressSwe: '',
    ingressEng: ''
  });

  useEffect(() => {
    const fetchReports = async () => {
      try {
        const response = await MakeRequest(null, 'content/references', 'get');
        if (response.data) {
          const filteredData = response.data
            .filter((ref) => 'Reports' === ref.type)
            .sort((a, b) => (a.order || 9999) - (b.order || 9999));
          setReports(filteredData);
        }
      } catch (error) {
        console.error('Error fetching reports:', error);
      }
    };
    
    const fetchPageContent = async () => {
      try {
        const response = await MakeRequest(null, 'content/pageContent?page=reports', 'get');
        if (response.data && response.data[0]) {
          setPageContent({
            ingressSwe: response.data[0].ingressSwe || '',
            ingressEng: response.data[0].ingressEng || ''
          });
        }
      } catch (error) {
        console.error('Error fetching page content:', error);
      }
    };
    
    fetchReports();
    fetchPageContent();
  }, []);

  const handleReferenceClick = (reference) => {
    navigate(`/references/${reference._id}`, { state: { reference } });
  };

  const bgColors = ['#f8f9fa', '#e9ecef', '#dee2e6']; // light gray variations

  const truncate150 = (text) =>
    text?.length > 150 ? text.slice(0, 150) + '...' : text;

  const canShowMore = visibleCount < reports.length;

  return (
    <>
      <Container className="my-lg-5 my-3">
        {/* Header row: title + back link inline on sm/md; split on lg+ */}
        <Row className="g-3 align-items-center mb-4">
          <Col xs="auto" className="d-flex align-items-center">
            <h1 className="fw-bold mb-0 me-3">{l('Rapporter', 'Reports')}</h1>
          </Col>
        </Row>

        {/* Intro paragraph: 12 cols on small/medium, 6 cols on lg+ */}
        <Row className="mb-2">
          <Col xs={12} lg={6}>
            <p className="text-muted lead mb-0">
              {pageContent.ingressSwe || pageContent.ingressEng ? (
                l(pageContent.ingressSwe, pageContent.ingressEng)
              ) : (
                l('Här är några av våra rapporter.', 'Here are some of our reports.')
              )}
            </p>
          </Col>
        </Row>

        {/* Cards */}
        <Row className="g-3 g-md-4 mt-1">
          {reports?.slice(0, visibleCount).map((report, index) => (
            <Col
              key={report._id?.$oid || report._id || index}
              xs={12}
              sm={6}
              lg={4}
              className="d-flex"
            >
              <Card
                className="h-100 shadow-sm w-100 position-relative"
                style={{
                  borderRadius: '15px',
                  backgroundColor: bgColors[index % bgColors.length],
                }}
              >
                <Card.Body className="d-flex flex-column">
                  <Card.Title className="mb-2">
                    {l(report.titleSwe, report.titleEng)}
                  </Card.Title>

                  <Card.Text
                    className="mb-3 flex-grow-1"
                    style={{ whiteSpace: 'pre-line' }}
                  >
                    {l(truncate150(report.contentSwe), truncate150(report.contentEng))}
                  </Card.Text>

                  {/* Use an anchor for proper stretched-link behavior */}
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleReferenceClick(report);
                    }}
                    className="stretched-link fw-bold"
                    style={{ color: 'var(--bs-primary)' }}
                    aria-label={l('Läs mer', 'Read more')}
                  >
                    {l('Läs mer →', 'Read more →')}
                  </a>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {canShowMore && (
          <div className="text-center mt-3">
            <Button variant="primary" onClick={() => setVisibleCount((v) => v + 12)}>
              {l('Visa mer', 'Show more')}
            </Button>
          </div>
        )}
      </Container>

    </>
  );
};

export default Reports;
